import en from 'commonAssets/i18n/en';
import es from 'commonAssets/i18n/es';



export default { en, es };
